import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable import/no-import-module-exports */
/* eslint-disable global-require */
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { createWrapper } from 'next-redux-wrapper';
import { enableMapSet } from 'immer';
import rootReducer from 'redux/reducers/index';
enableMapSet();
var bindMiddleware = function bindMiddleware(middleware) {
  var _require = require('redux-devtools-extension'),
    composeWithDevTools = _require.composeWithDevTools;

  // eslint-disable-next-line import/no-extraneous-dependencies
  var _require2 = require('redux-logger'),
    createLogger = _require2.createLogger;

  // do not log server-side redux actions
  middleware.push(createLogger({
    predicate: function predicate() {
      return typeof window !== 'undefined';
    }
  }));
  return composeWithDevTools(applyMiddleware.apply(void 0, _toConsumableArray(middleware)));
};
var makeStore = function makeStore() {
  var store = createStore(rootReducer, bindMiddleware([thunk]));

  // IF REDUCERS WERE CHANGED, RELOAD WITH INITIAL STATE
  if (module.hot) {
    module.hot.accept('./reducers', function () {
      var createNextReducer = require('./reducers').default;
      store.replaceReducer(createNextReducer(rootReducer));
    });
  }
  return store;
};

// serializeState only runs on the server, this tells its HYDRATE apart from client replays
var wrapper = createWrapper(makeStore, {
  debug: false,
  serializeState: function serializeState(state) {
    return _objectSpread(_objectSpread({}, state), {}, {
      fromServer: true
    });
  }
});
export { wrapper, makeStore };